import { Controller } from 'stimulus';

class ErrorPage extends Controller {
  connect() {
    this.frames = JSON.parse(this.data.get('frames'));
    this.currentFrame = 0;
    this.maxFrames = this.frames.length;

    this.play();
  }

  play() {
    const colour = '#00ff00';

    this.element.innerHTML = `
      <font color="${colour}"">
        <pre>${this.frames[this.currentFrame]}</pre>
      </font>
    `;

    this.currentFrame += 1;

    if (this.currentFrame >= this.maxFrames) {
      this.currentFrame = 0;
    }

    setTimeout(() => {
      this.play.call(this);
    }, 100);
  }
}

export default ErrorPage;
